var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "settings-container p-3" }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("h5", { staticClass: "fw-bold text-dark" }, [
        _vm._v(_vm._s(_vm.$t("settings.tabs.reports")))
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "opacity-10" })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "settings-card shadow-sm rounded border bg-white overflow-hidden mb-4"
      },
      _vm._l(_vm.sortedSettings, function(item, index) {
        return _c("div", { key: item.name }, [
          index === 0 ||
          item.category !== _vm.sortedSettings[index - 1].category
            ? _c(
                "div",
                {
                  staticClass:
                    "bg-light p-2 px-3 border-bottom fw-bold text-uppercase small text-muted d-flex align-items-center"
                },
                [
                  _c("i", { staticClass: "fa fa-chart-bar me-2 text-primary" }),
                  _vm._v("\n        " + _vm._s(item.category) + "\n      ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row align-items-center mx-0 py-3 border-bottom hover-bg transition-all"
            },
            [
              _c("div", { staticClass: "col-md-5" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label fw-semibold mb-0 cursor-pointer",
                    attrs: { for: "report-input-" + index }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.name) + "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                item.type === 1
                  ? _c("div", { staticClass: "form-check form-switch" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.isChecked,
                            expression: "item.isChecked"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          role: "switch",
                          id: "report-input-" + index
                        },
                        domProps: {
                          checked: Array.isArray(item.isChecked)
                            ? _vm._i(item.isChecked, null) > -1
                            : item.isChecked
                        },
                        on: {
                          change: function($event) {
                            var $$a = item.isChecked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(item, "isChecked", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    item,
                                    "isChecked",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(item, "isChecked", $$c)
                            }
                          }
                        }
                      })
                    ])
                  : _c("div", { staticClass: "input-group input-group-sm" }, [
                      item.type === 2
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.value,
                                expression: "item.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "report-input-" + index
                            },
                            domProps: { value: item.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "value", $event.target.value)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 3
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.value,
                                expression: "item.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              id: "report-input-" + index
                            },
                            domProps: { value: item.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "value", $event.target.value)
                              }
                            }
                          })
                        : _vm._e()
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                item.default
                  ? _c("small", { staticClass: "text-muted d-block small" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "badge rounded-pill bg-light text-secondary border fw-normal"
                        },
                        [
                          _vm._v(
                            "\n              Default: " +
                              _vm._s(item.default) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary px-4 d-flex align-items-center",
          attrs: { type: "button" },
          on: { click: _vm.postSettings }
        },
        [
          _c("i", { staticClass: "fa fa-check-circle me-2" }),
          _vm._v("\n      " + _vm._s(_vm.$t("btnUpdate")) + "\n    ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }